import axios from '@/libs/api.request'

export const couponTemplateList = () => {
  return axios.request({
    url: 'coupon/admin/templates',
    method: 'get',
  })
}

export const couponTemplateCreate = (data) => {
  return axios.request({
    url: 'coupon/admin/templates',
    method: 'post',
    data,
  })
}

export const couponTemplateUpdate = (id, data) => {
  return axios.request({
    url: `coupon/admin/templates/${id}`,
    method: 'put',
    data,
  })
}

export const couponGrant = (data) => {
  return axios.request({
    url: 'coupon/admin/grant',
    method: 'post',
    data,
  })
}
